import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import useStyles from './styles';
import { inputDataCustom } from '../../../../../utils/custom_prop_types/customPropTypes';

export default function RevertButton({
  nestedProduct,
  inputData,
  setInputDataToSend,
  setAddedProducts,
  addedProducts,
}) {
  const classes = useStyles();

  const deleteAccessory = () => {
    const deletedAccessories = [];

    inputData.accessoriesFlat.forEach((accessory) => {
      if (accessory.id === `${nestedProduct['@id']}${nestedProduct.association}`
        || deletedAccessories.includes(accessory.parentId)
      ) {
        deletedAccessories.push(accessory.id);
      }
    });

    const filteredAccessories = inputData.accessoriesFlat
      .filter((accessory) => !deletedAccessories.includes(accessory.id));

    const filteredAddedAccessories = addedProducts
      .filter((addedProduct) => !deletedAccessories.includes(addedProduct));

    setAddedProducts(filteredAddedAccessories);

    setInputDataToSend('accessoriesFlat', filteredAccessories);
  };

  return (
    <Button
      className={classes.addButton}
      variant="contained"
      color="secondary"
      onClick={deleteAccessory}
      data-iri={nestedProduct['@id']}
      data-value={nestedProduct.association}
    >
      <DeleteIcon />
    </Button>
  );
}

RevertButton.propTypes = {
  nestedProduct: PropTypes.objectOf(PropTypes.any).isRequired,
  inputData: inputDataCustom.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
  addedProducts: PropTypes.arrayOf(PropTypes.any).isRequired,
  setAddedProducts: PropTypes.func.isRequired,
};
